import { Observable } from "./Observable.js";
import { canUseSymbol } from "../common/canUse.js";
export function fixObservableSubclass(subclass) {
    function set(key) {
        Object.defineProperty(subclass, key, { value: Observable });
    }
    if (canUseSymbol && Symbol.species) {
        set(Symbol.species);
    }
    set("@@species");
    return subclass;
}
//# sourceMappingURL=subclassing.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/utilities/observables/subclassing.js
// module id = 882
// module chunks = 4